import { useEffect, useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from 'lucide-react';
import { getConsent, setConsent } from '@/hooks/useCookieConsent';

const CookieConsent = () => {
  const { lang } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    setConsent('accepted');
    setVisible(false);
  };

  const essentialOnly = () => {
    setConsent('essential');
    setVisible(false);
  };

  const cs = lang === 'cs';

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-6 md:max-w-md"
        >
          <div className="bg-card border border-border rounded-xl p-4 shadow-2xl backdrop-blur-sm">
            <div className="flex items-start gap-3">
              <Cookie className="w-5 h-5 text-primary mt-0.5 shrink-0" />
              <div className="flex-1">
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {cs
                    ? 'Používáme nezbytné cookies pro fungování webu. Pro přehrávání videí (YouTube) a zobrazení Facebook příspěvků potřebujeme Váš souhlas. Více v '
                    : 'We use essential cookies for the website to work. For video playback (YouTube) and Facebook posts we need your consent. More in our '}
                  <Link to="/privacy" className="text-primary hover:underline">
                    {cs ? 'zásadách ochrany osobních údajů' : 'privacy policy'}
                  </Link>
                  .
                </p>
                <div className="mt-3 flex flex-wrap gap-2">
                  <button
                    onClick={acceptAll}
                    className="px-4 py-1.5 bg-primary text-primary-foreground text-sm font-medium rounded-lg hover:bg-primary/90 transition-colors"
                  >
                    {cs ? 'Přijmout vše' : 'Accept all'}
                  </button>
                  <button
                    onClick={essentialOnly}
                    className="px-4 py-1.5 bg-transparent border border-border text-muted-foreground text-sm font-medium rounded-lg hover:text-foreground hover:border-primary/40 transition-colors"
                  >
                    {cs ? 'Pouze nezbytné' : 'Essential only'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
